// Der Kopf der Karten Bestellung, Dachpartie, Bodenpartie (E3c, S3 und S4):
// Zeichen, Titel und der Stand des Schritts aus der Kette als Chip – darunter
// sein Grund in einem Satz („noch offen: Module“, „Termin geändert – Mail
// erneut öffnen“) und ein Hinweis („Unterlage erneut senden?“).

import { SCHRITT_STAND_WORTE, type SchrittInDerKette, type SchrittStand } from "@happy-energy/kern";
import { Chip, Ikon, type ChipArt, type IkonName } from "@happy-energy/oberflaeche";

/** Wie der Stand eines Schritts als Chip aussieht – wie in der Leiste. */
export const STAND_CHIP: Record<SchrittStand, ChipArt> = {
  erledigt: "ok",
  "vor-dem-update": "ok",
  offen: "lime",
  "wieder-offen": "warn",
  "geht-noch-nicht": "sp",
};

export function KartenKopf({ ikon, titel, schritt }: { ikon: IkonName; titel: string; schritt: SchrittInDerKette }) {
  return (
    <div className="ablauf-platz-kopf">
      <Ikon name={ikon} />
      <h3>{titel}</h3>
      <Chip art={STAND_CHIP[schritt.stand]}>{SCHRITT_STAND_WORTE[schritt.stand]}</Chip>
    </div>
  );
}

/**
 * Gründe, die nur sagen, was der Chip „erledigt“ schon sagt – sie stehen nicht
 * noch einmal darunter (S7, der Blick auf die Karten): Was bestellt,
 * beauftragt oder eingeteilt ist, zeigt die Karte darunter mit wann und wer.
 */
const NUR_DAS_WORT = new Set(["bestellt", "beauftragt", "eingeteilt"]);

export function StandSatz({ schritt }: { schritt: SchrittInDerKette }) {
  const grund = schritt.stand === "erledigt" && schritt.grund !== null && NUR_DAS_WORT.has(schritt.grund) ? null : schritt.grund;
  return (
    <>
      {grund && <p className={schritt.stand === "wieder-offen" ? "akte-geaendert ablauf-grund" : "ablauf-grund"}>{grund}</p>}
      {schritt.hinweis && (
        <p className="akte-geaendert">
          <Ikon name="achtung" groesse="k" /> {schritt.hinweis}
        </p>
      )}
    </>
  );
}
